import React, { useReducer, useEffect, useContext } from "react";
import axios from "axios";
import ProjectContext from "./ProjectContext";
import ProjectReducer from "./ProjectReducer";
import AuthContext from "../auth/AuthContext";
//import data from "../../data/projects.json";
import { ProjectRoutes } from "../../config/APIRoutes";
// import IntelliFiberRoles from "../../data/intelli-fiber-roles.json";
import IntelliFiberUserRoles from "../../data/intelli-fiber-user-roles.json";
import ProjectUserRoles from "../../data/project-user-roles.json";
import Permissions from "../../data/permissions.json";
import RolePermissions from "../../data/role-permissions.json";
import {
  getFeatureData,
  processProjectData,
  queryProjectViewData,
  queryProjectDataWithFilter,
  groupTypes,
  queryProjectData,
  queryServiceAreaData,
  queryUnitsConfig,
  queryProjectFeatures,
  queryProjectDatabyObjectId,
} from "../../utils/ProjectAPI";
import {
  FETCH_PROJECTS,
  SET_PROJECTS,
  SELECT_PROJECT,
  FETCH_PROJECTS_ERROR,
  SET_FLAGS,
  FETCH_SERVICEAREA,
  FETCH_ALL_SERVICEAREA,
  FETCH_ROLES,
  FETCH_UNITS_CONFIG,
  FETCH_PROJECT_UNITS_RAW,
  FETCH_PROJECT_UNITS_CONFIG,
  CLEAR_PROJECT_UNITS_CONFIG,
  FETCH_USERS,
  FETCH_ENTERPRISE_USERS,
  FETCH_PROJECT_ASSIGNMENTS,
  UPDATE_PROJECT,
  SET_AFTER_RELOAD,
  FETCH_WORKFLOW_STATUS,
  FETCH_SERVICEAREA_FEATURES,
  FETCH_ASSET_GROUPS,
  FETCH_ASSET_TYPES,
  FETCH_INTELLI_FIBER_ROLES,
  FETCH_INTELLI_FIBER_USER_ROLES,
  FETCH_PROJECT_USER_ROLES,
  FETCH_PERMISSIONS,
  FETCH_PHASES,
  FETCH_ROLE_PERMISSIONS,
  APPS_LOADING,
  FETCH_APPS_ERROR,
  FETCH_USERROLES,
  UPDATE_USERROLES,
  CREATE_USERROLES,
  DELETE_USERROLES,
  CREATE_CLIENTPROJECTS,
  CREATE_USERPROJECTS,
  DELETE_USERPROJECTS,
  DELETE_CLIENTPROJECTS,
} from "../../data/constants";

import { ServiceIndex, ViewIndex } from "../../config/APIRoutes";

const API_BASE_URL = process.env.REACT_APP_IFCLIENT_API_BASE_URL;

const ProjectStore = (props) => {
  //const localState = window.localStorage.getItem("jsi-intelli-project");
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const initialState = {
    projects: [],
    selectedProject: null,
    serviceAreas: [],
    assetGroups: [],
    assetTypes: [],
    serviceAreaFeatures: [],
    serviceAreasAll: [],
    workflow: [],
    error: null,
    loaded: false,
    loading: false,
    roles: [],
    assetLookup: [],
    assetSuffixes: [],
    projectAssets: [],
    projectRawAssets: [],
    projectSuffixes: [],
    users: [],
    intelliFiberRoles: [],
    intelliFiberUserRoles: [],
    intelliFiberProjectUserRoles: [],
    permissions: [],
    rolePermissions: [],
    phases: [],
    clientUserList: [],
    clientGroup: [],
  };
  const [state, dispatch] = useReducer(ProjectReducer, initialState);

  window.addEventListener("beforeunload", () => {
    console.log("Before Unload");
    window.sessionStorage.setItem(
      "integratedWorkflowState",
      JSON.stringify(state)
    );
  });

  //const [state, dispatch] = useReducer(AuthReducer, initialState);
  useEffect(() => {
    //   state.projects = JSON.parse(data);
    console.log("CURRENT STATE:", state);
    const savedState = window.sessionStorage.getItem("integratedWorkflowState");
    if (savedState) {
      console.log("RELOAD_STATE", JSON.parse(savedState));
      dispatch({
        type: SET_AFTER_RELOAD,
        payload: JSON.parse(savedState),
      });

      window.sessionStorage.removeItem("integratedWorkflowState");
    }
    //eslint-disable-next-line
  }, []);

  //   useEffect(() => {
  //     const localState = JSON.stringify(state);
  //     try {
  //       window.localStorage.setItem("jsi-intelli-project", localState);
  //     } catch (err) {
  //       console.log("Error in storing local state");
  //     }
  //     console.log("Projects state", localState, localState.selectedProject);
  //   }, [state]);

  // const getProjects = async (token) => {
  //   console.log("INSIDE LOg");
  //   const config = {
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     },
  //   };
  //   var bodyFormData = new URLSearchParams();
  //   bodyFormData.append("where", "1=1");
  //   bodyFormData.append("f", TokenRequest.format);
  //   bodyFormData.append("token", token);
  //   bodyFormData.append("outFields", "*");
  //   dispatch({
  //     type: SET_FLAGS,
  //     payload: { loading: true, loaded: false },
  //   });
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const resp = await axios.post(
  //         ProjectRoutes.projectPostQuery,
  //         bodyFormData,
  //         config
  //       );
  //       console.log("PROJECT list:", resp.data);
  //       const result = getFeatureData(resp.data);
  //       dispatch({
  //         type: FETCH_PROJECTS,
  //         payload: result,
  //       });
  //       resolve(result);
  //     } catch (err) {
  //       // console.log("Error", err);
  //       dispatch({
  //         type: FETCH_PROJECTS_ERROR,
  //         payload: err,
  //       });
  //       reject(err);
  //     }
  //   });
  // };

  const getProjectsV2 = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const projectList = await queryProjectData(ServiceIndex.Projects);
        dispatch({
          type: FETCH_PROJECTS,
          payload: projectList,
        });
        resolve(projectList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getAssetGroupsV2 = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const groupList = await queryProjectData(
          ServiceIndex.ProjectAssetGroup
        );
        let sortedList = groupList.sort((a, b) =>
          a.AssetGroupType.toLowerCase() > b.AssetGroupType.toLowerCase()
            ? 1
            : -1
        );
        console.log("groupList", groupList, sortedList);
        dispatch({
          type: FETCH_ASSET_GROUPS,
          payload: sortedList,
        });
        resolve(sortedList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getAssetTypesV2 = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const assetTypeList = await queryProjectData(
          ServiceIndex.ProjectAssetTypes
        );
        console.log("assetTypeList", assetTypeList);
        let sortedList = assetTypeList.sort((a, b) =>
          a.AssetName.toLowerCase() > b.AssetName.toLowerCase() ? 1 : -1
        );
        dispatch({
          type: FETCH_ASSET_TYPES,
          payload: sortedList,
        });
        resolve(sortedList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectbyObjectId = async (ObjectId) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const project = await queryProjectDatabyObjectId(
          ServiceIndex.Projects,
          ObjectId
        );
        dispatch({
          type: SELECT_PROJECT,
          payload: project[0],
        });
        resolve(project);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectServiceAreasV2 = async (projectID) => {
    // dispatch({
    //   type: SET_FLAGS,
    //   payload: { loading: true, loaded: false },
    // });
    return new Promise(async (resolve, reject) => {
      try {
        const projectList = await queryProjectViewData(
          ViewIndex.ServiceAreaProject,
          projectID
        );
        // dispatch({
        //   type: FETCH_PROJECTS,
        //   payload: projectList,
        // });
        resolve(projectList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const generateNewProjectID = () => {
    let newID = "00000001";
    console.log("state.projects.length", state.projects.length);
    if (state.projects.length > 0) {
      let IDs = state.projects
        .map(({ ID }) => parseInt(ID))
        .filter((id) => !isNaN(id)); // exclude invalid IDs
      console.log("new Map", IDs);
      console.log("Max ID", Math.max(...IDs));
      newID = (Math.max(...IDs) + 1).toString();
    }

    console.log("NEW ID", newID);
    return newID;
  };

  const generateNewUnitID = () => {
    let newID = "00000001";
    console.log("state.units.length", state.assetTypes.length);
    if (state.assetTypes.length > 0) {
      let IDs = state.assetTypes
        .map(({ AssetTypeID }) => parseInt(AssetTypeID))
        .filter((id) => !isNaN(id)); // exclude invalid IDs
      console.log("new Map", IDs);
      console.log("Max ID", Math.max(...IDs));
      newID = (Math.max(...IDs) + 1).toString();
    }

    console.log("NEW ID", newID);
    return newID;
  };

  const getServiceAreasV2 = async (ProjectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const areaList = await queryProjectData(
          ServiceIndex.ServiceArea,
          ProjectID
        );
        let sortedList = areaList.sort((a, b) =>
          a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1
        );
        dispatch({
          type: FETCH_SERVICEAREA,
          payload: sortedList,
        });
        resolve(sortedList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getServiceAreaFeaturesV2 = async (ProjectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const areaFeatureList = await queryProjectFeatures(
          ServiceIndex.ServiceArea,
          ProjectID
        );
        dispatch({
          type: FETCH_SERVICEAREA_FEATURES,
          payload: areaFeatureList,
        });
        resolve(areaFeatureList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getWorkflowStatusV2 = async (ServiceAreaID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const areaList = await queryServiceAreaData(
          ServiceIndex.Workflow,
          ServiceAreaID
        );
        dispatch({
          type: FETCH_WORKFLOW_STATUS,
          payload: areaList,
        });
        resolve(areaList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getAllServiceAreasV2 = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const areaList = await queryProjectData(ServiceIndex.ServiceArea);
        dispatch({
          type: FETCH_ALL_SERVICEAREA,
          payload: areaList,
        });
        resolve(areaList);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const generateNewServiceAreaID = () => {
    let newID = "000000000001";
    console.log("state.serviceAreasAll.length", state.serviceAreasAll.length);
    if (state.projects.length > 0) {
      let IDs = state.projects
        .map(({ ID }) => parseInt(ID))
        .filter((id) => !isNaN(id)); // exclude invalid IDs
      console.log("new Map", IDs);
      console.log("Max ID", Math.max(...IDs));
      newID = (Math.max(...IDs) + 1).toString();
    }

    console.log("NEW ID", newID);
    return newID;
  };

  const getRolesV2 = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(ServiceIndex.ProjectRoles);
        dispatch({
          type: FETCH_ROLES,
          payload: result,
        });
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Add user to assignment table with the role
  //Input object data with role,username
  const assignRoleToUserV2 = async (data) => {
    console.log("ADD ROLES DATA ", data);

    return new Promise(async (resolve, reject) => {
      try {
        if (data?.length > 0) {
          dispatch({
            type: SET_FLAGS,
            payload: { loading: true, loaded: false },
          });
          const result = await processProjectData(
            ServiceIndex.ProjectAssignments,
            data,
            "ADD"
          );
          console.log("ADD ", data, "REsult", result);

          console.log("ADD ROLES DATA2 ", data);
          await getProjectAssignmentsV2(data[0].ProjectID);
          // if (timer)clearTimeout(timer);
          resolve(true);
        }
        resolve(false);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Delete specific objectId
  //Input: ObjectId
  const deleteFromTableV2 = (deleteID, projectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const deleteIdData = {};
        deleteIdData.OBJECTID = deleteID;
        const result = await processProjectData(
          ServiceIndex.ProjectAssignments,
          deleteIdData,
          "DELETE"
        );
        console.log(
          "DELETE ",
          deleteID,
          "projectID",
          projectID,
          "RESULT",
          result
        );
        // () => getProjectAssignmentsV2()
        await getProjectAssignmentsV2(projectID);
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Get Enterpirse user data from table
  const getEnterpriseUsersV2 = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(ServiceIndex.EnterpriseUsers);
        console.log(`Enterprise roles result :`, result);
        let sortedUser = result.sort((a, b) =>
          a.UserID.toLowerCase() > b.UserID.toLowerCase() ? 1 : -1
        );
        dispatch({
          type: FETCH_ENTERPRISE_USERS,
          payload: sortedUser,
        });
        resolve(sortedUser);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Get Project assignments table
  const getProjectAssignmentsV2 = async (projectID) => {
    console.log(`Fetcing USer assginments for Project ${projectID}`);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(
          ServiceIndex.ProjectAssignments,
          projectID
        );
        console.log(
          `Project ${projectID} assignments new:${JSON.stringify(result)}`
        );
        dispatch({
          type: FETCH_PROJECT_ASSIGNMENTS,
          payload: result,
        });

        console.log("CURRENT STATE:", state);
        resolve(result);
      } catch (err) {
        console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getAssetLookupV2 = async () => {
    // dispatch({
    //   type: SET_FLAGS,
    //   payload: { loading: true, loaded: false },
    // });
    return new Promise(async (resolve, reject) => {
      try {
        let result = await queryProjectViewData(ViewIndex.AssetMaster);
        // console.log("Suffxies",result);
        let groupedResult = groupTypes(result);
        dispatch({
          type: FETCH_UNITS_CONFIG,
          payload: { result, groupedResult },
        });
        resolve(groupedResult);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectRawAssetsV2 = async (projectID) => {
    // dispatch({
    //   type: SET_FLAGS,
    //   payload: { loading: true, loaded: false },
    // });
    return new Promise(async (resolve, reject) => {
      try {
        let result = await queryProjectData(
          ServiceIndex.ProjectUnitAssignments,
          projectID
        );
        console.log("RESULT", result);
        if (result && result.length > 0) {
          // let groupedResult = groupTypes(result, state.assetLookup, "raw");
          // console.log("groupedResult", groupedResult);
          dispatch({
            type: FETCH_PROJECT_UNITS_RAW,
            payload: result,
          });
          resolve({ groupedResult: result, result });
        } else {
          resolve({ groupedResult: [], result: [] });
        }
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectAssetsV2 = async (projectID) => {
    // dispatch({
    //   type: SET_FLAGS,
    //   payload: { loading: true, loaded: false },
    // });
    return new Promise(async (resolve, reject) => {
      try {
        let result = await queryProjectViewData(
          ViewIndex.ProjectUnitAssignments,
          projectID
        );
        console.log("Project Result", result);
        let groupedResult = groupTypes(result, state.assetLookup, "project");
        console.log("$$$PROJ CONFIG ", groupedResult);
        dispatch({
          type: FETCH_PROJECT_UNITS_CONFIG,
          payload: { result, groupedResult },
        });
        resolve(groupedResult);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectAssetsByUnit = async (AssetTypeID) => {
    // dispatch({
    //   type: SET_FLAGS,
    //   payload: { loading: true, loaded: false },
    // });
    let where = `AssetTypeID='${AssetTypeID}'`;
    console.log("Project Unit Check for:", where);
    return new Promise(async (resolve, reject) => {
      try {
        let result = await queryProjectDataWithFilter(
          ServiceIndex.ProjectUnitAssignments,
          where
        );
        console.log("Project Result", result);

        resolve(result.length > 0);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const addRoleV2 = async (roles) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        roles.map(async (item) => {
          const result = await processProjectData(
            ServiceIndex.ProjectRoles,
            item,
            "ADD"
          );
          console.log("ADD ", item, "REsult", result);
        });
        await getRolesV2();
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const addProjectUnitsV2 = async (units) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.ProjectUnitAssignments,
          units,
          "ADD"
        );
        console.log("REsult", result);

        // await getProjectAssetsV2();
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const addNewUnitsV2 = async (units) => {
    // dispatch({
    //   type: SET_FLAGS,
    //   payload: { loading: true, loaded: false },
    // });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.ProjectAssetTypes,
          units,
          "ADD"
        );
        console.log("REsult", result);

        // await getProjectAssetsV2();
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const updateProjectUnitV2 = async (obj) => {
    console.log("OBJECT VALUE", obj);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.ProjectUnitAssignments,
          obj,
          "UPDATE"
        );
        console.log("REsult", result);
        // const project = await queryProjectData(ServiceIndex.Projects, obj.ID);
        // console.log("Updated REsult", project);
        // dispatch({
        //   type: UPDATE_PROJECT,
        //   payload: project,
        // });
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const updateProjectStatusV2 = async (obj) => {
    console.log("OBJECT VALUE", obj);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Projects,
          obj,
          "UPDATE"
        );
        console.log("REsult", result);
        const project = await queryProjectData(ServiceIndex.Projects, obj.ID);
        console.log("Updated REsult", project);
        dispatch({
          type: UPDATE_PROJECT,
          payload: project,
        });
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const updateWorkflowStatusV2 = async (obj, action) => {
    console.log("OBJECT VALUE", obj);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Workflow,
          obj,
          action
        );
        console.log("REsult", result);
        const workflow = await queryServiceAreaData(
          ServiceIndex.Workflow,
          obj.SA_ID
        );
        console.log("Updated REsult", workflow);
        dispatch({
          type: FETCH_WORKFLOW_STATUS,
          payload: workflow,
        });
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const updateServiceAreaStatusV2 = async (obj) => {
    console.log("OBJECT VALUE", obj);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.ServiceArea,
          obj,
          "UPDATE"
        );
        console.log("REsult", result);
        await getServiceAreasV2(obj.ProjectID);
        dispatch({
          type: SET_FLAGS,
          payload: { loading: false, loaded: true },
        });
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const deleteProjectUnitsV2 = async (units) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.ProjectUnitAssignments,
          units,
          "DELETE"
        );
        console.log("REsult", result);

        // await getProjectAssetsV2();
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const setProjects = (projectsList) => {
    // console.log("Search for", search);
    dispatch({
      type: SET_PROJECTS,
      payload: projectsList,
    });
  };

  const clearProjectAssets = () => {
    // console.log("Search for", search);
    dispatch({
      type: CLEAR_PROJECT_UNITS_CONFIG,
      payload: [],
    });
  };

  const selectProject = (project) => {
    // console.log("Search for", search);
    dispatch({
      type: SELECT_PROJECT,
      payload: project,
    });
  };

  const getIntelliFiberRoles = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(ServiceIndex.IntelliFiberRoles);
        dispatch({
          type: FETCH_INTELLI_FIBER_ROLES,
          payload: result,
        });
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getIntelliFiberUserRoles = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectViewData(
          ViewIndex.IntelliFiberUserRoles
        );
        let sortedUser = result.sort((a, b) =>
          a.UserID.toLowerCase() > b.UserID.toLowerCase() ? 1 : -1
        );
        dispatch({
          type: FETCH_INTELLI_FIBER_USER_ROLES,
          payload: sortedUser,
        });
        resolve(sortedUser);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectUserRoles = async (projectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectViewData(
          ViewIndex.ProjectUserRoles,
          projectID
        );
        let sortedUser = result.sort((a, b) =>
          a.UserID.toLowerCase() > b.UserID.toLowerCase() ? 1 : -1
        );
        dispatch({
          type: FETCH_PROJECT_USER_ROLES,
          payload: sortedUser,
        });
        resolve(sortedUser);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const updateProjectDetails = async (project) => {
    console.log("OBJECT VALUE", project);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Projects,
          project,
          "UPDATE"
        );
        console.log("Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const updatePhaseScopeHistory = async (projectScope) => {
    console.log("OBJECT VALUE", projectScope);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_PhaseScopeHistory,
          projectScope,
          "ADD"
        );
        console.log("Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const getConstructionDashboardLink = async (ProjectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(
          ServiceIndex.Intelli_Fiber_ProjectItem,
          ProjectID
        );
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getRisks = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(ServiceIndex.Intelli_Fiber_Risks);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const addMonthlyStatusRisk = async (risk, action) => {
    console.log("OBJECT VALUE", risk);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_StatusRisks,
          risk,
          action
        );
        console.log("Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const deleteMonthlyStatusRisk = (deleteID) => {
    console.log("OBJECT VALUE", deleteID);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const deleteIdData = {};
        deleteIdData.OBJECTID = deleteID;
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_StatusRisks,
          deleteIdData,
          "DELETE"
        );
        console.log("Result", result);
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const addProjectMonthlyStatus = async (status, action) => {
    console.log("OBJECT VALUE", status);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_MonthlyStatus,
          status,
          action
        );
        console.log("Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const deleteProjectMonthlyStatus = (deleteID) => {
    console.log("OBJECT VALUE", deleteID);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const deleteIdData = {};
        deleteIdData.OBJECTID = deleteID;
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_MonthlyStatus,
          deleteIdData,
          "DELETE"
        );
        console.log("Result", result);
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const updateProjectScopeHistory = async (projectScope) => {
    console.log("OBJECT VALUE", projectScope);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_ProjectScopeHistory,
          projectScope,
          "ADD"
        );
        console.log("Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const updateProjectScope = async (projectScope, action) => {
    console.log("OBJECT VALUE", projectScope);
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_ProjectScope,
          projectScope,
          action
        );
        console.log("Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const getProjectScopeHistoryView = async (projectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectViewData(
          ViewIndex.ProjectScopeHistoryView,
          projectID
        );
        // dispatch({
        //   type: FETCH_PROJECT_USER_ROLES,
        //   payload: result,
        // });
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectMonthlyStatusView = async (projectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectViewData(
          ViewIndex.ProjectMonthlyStatusView,
          projectID
        );
        console.log("fetchProjectScopeHistoryView Result", result);
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectScopeView = async (projectID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectViewData(
          ViewIndex.ProjectScopeView,
          projectID
        );
        // dispatch({
        //   type: FETCH_PROJECT_USER_ROLES,
        //   payload: result,
        // });
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getMonthlyStatusByObjectId = async (ObjectId) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectDatabyObjectId(
          ServiceIndex.Intelli_Fiber_MonthlyStatus,
          ObjectId
        );
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getProjectHistoryByObjectId = async (ObjectId) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectDatabyObjectId(
          ServiceIndex.Intelli_Fiber_ProjectScopeHistory,
          ObjectId
        );
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getPemissions = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(
          ServiceIndex.IntelliFiberPermissions
        );
        dispatch({
          type: FETCH_PERMISSIONS,
          payload: result,
        });
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getRolePermissions = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        // const result = await queryProjectData(ServiceIndex.ProjectRoles);
        dispatch({
          type: FETCH_ROLE_PERMISSIONS,
          payload: RolePermissions,
        });
        resolve(RolePermissions);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //
  const addIntelliFiberUserRole = async (formData) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        if (formData.length > 0) {
          const result = await processProjectData(
            ServiceIndex.IntelliFiberUserRoles,
            formData,
            "ADD"
          );
          console.log("REsult", result);
          await getIntelliFiberUserRoles();
          resolve(true);
        }
        resolve(false);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const deleteIntelliFiberUserRole = (deleteID) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const deleteIdData = {};
        deleteIdData.OBJECTID = deleteID;
        const result = await processProjectData(
          ServiceIndex.IntelliFiberUserRoles,
          deleteIdData,
          "DELETE"
        );
        console.log("DELETE ", deleteID, "RESULT", result);
        // () => getProjectAssignmentsV2()
        await getIntelliFiberUserRoles();
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const addProjectUserRole = async (formData) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        if (formData.length > 0) {
          const result = await processProjectData(
            ServiceIndex.Intelli_Fiber_ProjectUserRoles,
            formData,
            "ADD"
          );
          console.log("REsult", result);
          await getProjectUserRoles(formData[0].ProjectID);
          resolve(true);
        }
        resolve(false);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(false);
      }
    });
  };

  const deleteProjectUserRole = (formData) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        // const deleteIdData = {};
        // deleteIdData.OBJECTID =  formData.OBJECTID;
        const result = await processProjectData(
          ServiceIndex.Intelli_Fiber_ProjectUserRoles,
          formData,
          "DELETE"
        );
        console.log("DELETE ", formData, "RESULT", result);
        // () => getProjectAssignmentsV2()
        await getProjectUserRoles(formData.ProjectID);
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const deleteIntelliFiberUnit = (formData) => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        // const deleteIdData = {};
        // deleteIdData.OBJECTID =  formData.OBJECTID;
        const result = await processProjectData(
          ServiceIndex.ProjectAssetTypes,
          formData,
          "DELETE"
        );
        console.log("DELETE ", formData, "RESULT", result);
        // () => getProjectAssignmentsV2()
        await getAssetTypesV2();
        resolve(true);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getPhases = async () => {
    dispatch({
      type: SET_FLAGS,
      payload: { loading: true, loaded: false },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await queryProjectData(ServiceIndex.Intelli_Fiber_Phase);
        dispatch({
          type: FETCH_PHASES,
          payload: result,
        });
        resolve(result);
      } catch (err) {
        // console.log("Error", err);
        dispatch({
          type: FETCH_PROJECTS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getUserRoleType = () => {
    //check User's Role
    if (state.intelliFiberUserRoles && state.intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = state.intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  const hasUserAccessToProject = (projectID) => {
    if (
      state.intelliFiberProjectUserRoles &&
      state.intelliFiberProjectUserRoles.length > 0
    ) {
      const projectRoles = state.intelliFiberProjectUserRoles.filter(
        (item) => item.UserID === user?.userID && item.ProjectID === projectID
      );
      return projectRoles.length > 0;
    }
    return false;
  };
  /** Intelli-Fiber-Client-APIs **/

  const getClients = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(`${API_BASE_URL}/clients`, config);
        // console.log("APPS", res);
        let sortedList = res.data.sort((a, b) =>
          a.ClientName.toLowerCase() > b.ClientName.toLowerCase() ? 1 : -1
        );
        // console.log("APPS", res);
        dispatch({
          type: "SET_CLIENT_USER_LIST",
          payload: sortedList,
        });
        resolve(sortedList);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getAllUsers = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(`${API_BASE_URL}/users`, config);
        // console.log("APPS", res);
        // dispatch({
        //   type: FETCH_USERS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getAllRoles = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(`${API_BASE_URL}/roles`, config);
        // console.log("APPS", res);
        // dispatch({
        //   type: FETCH_ROLES,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getAllProjects = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(`${API_BASE_URL}/projects`, config);
        // console.log("APPS", res);
        // dispatch({
        //   type: FETCH_PROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getClientProjects = async (ClientID) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(
          `${API_BASE_URL}/clientprojects?clientid=${ClientID}`,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: FETCH_CLIENTPROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getUserProjects = async (UserID, RoleID) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(
          `${API_BASE_URL}/userprojects?userid=${UserID}&roleid=${RoleID}`,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: FETCH_USERPROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getAllUserRoles = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.get(`${API_BASE_URL}/userroles`, config);
        // console.log("APPS", res);
        // dispatch({
        //   type: FETCH_USERROLES,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching UserRoles", status: 504 },
        });
        reject(null);
      }
    });
  };

  const updateUserRoles = async (UserRole) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.put(
          `${API_BASE_URL}/userroles`,
          UserRole,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: UPDATE_USERROLES,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating User Role", status: 504 },
        });
        reject(null);
      }
    });
  };

  const createUserRoles = async (UserRole) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.post(
          `${API_BASE_URL}/userroles`,
          UserRole,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: CREATE_USERROLES,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating User Role", status: 504 },
        });
        reject(null);
      }
    });
  };

  const deleteUserRoles = async (UserRole) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.delete(
          `${API_BASE_URL}/userroles?userid=${UserRole.UserID}&userroleid=${UserRole.UserRoleID}`,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: DELETE_USERROLES,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating User Role", status: 504 },
        });
        reject(null);
      }
    });
  };

  const createUserProjects = async (UserProject) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.post(
          `${API_BASE_URL}/userprojects`,
          UserProject,
          config
        );
        console.log("APPS", res);
        // dispatch({
        //   type: CREATE_USERPROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating User Role", status: 504 },
        });
        reject(null);
      }
    });
  };

  const deleteUserProjects = async (UserProject) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        let projectIDs = "";
        UserProject.Projects.forEach((ID) => {
          projectIDs = projectIDs + `&projectid=${ID}`;
        });
        const res = await axios.delete(
          `${API_BASE_URL}/userprojects?userid=${UserProject.UserID}&roleid=${UserProject.RoleID}${projectIDs}`,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: DELETE_USERPROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in deleting User Projects", status: 504 },
        });
        reject(null);
      }
    });
  };

  const createClientProjects = async (ClientProject) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        const res = await axios.post(
          `${API_BASE_URL}/clientprojects`,
          ClientProject,
          config
        );
        console.log("APPS", res);
        // dispatch({
        //   type: CREATE_CLIENTPROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating User Role", status: 504 },
        });
        reject(null);
      }
    });
  };

  const deleteClientProjects = async (ClientProject) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        // dispatch({
        //   type: APPS_LOADING,
        // });
        let projectIDs = "";
        ClientProject.Projects.forEach((ID) => {
          projectIDs = projectIDs + `&projectid=${ID}`;
        });
        const res = await axios.delete(
          `${API_BASE_URL}/clientprojects?clientid=${ClientProject.ClientID}&${projectIDs}`,
          config
        );
        // console.log("APPS", res);
        // dispatch({
        //   type: DELETE_CLIENTPROJECTS,
        //   payload: res.data,
        // });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in deleting Client Project", status: 504 },
        });
        reject(null);
      }
    });
  };

  const setClientUserList = (clientUserList) => {
    dispatch({
      type: "SET_CLIENT_USER_LIST",
      payload: clientUserList,
    });
  };

  const setClientGroups = (clientGroup) => {
    dispatch({
      type: "SET_CLIENT_GROUP",
      payload: clientGroup,
    });
  };

  const createClient = async (Client) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });
        const res = await axios.post(`${API_BASE_URL}/client`, Client, config);
        await getClients();
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in creating client", status: 504 },
        });
        reject(null);
      }
    });
  };

  const updateClient = async (Client) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });
        const res = await axios.put(`${API_BASE_URL}/client`, Client, config);
        await getClients();
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating Client", status: 504 },
        });
        reject(null);
      }
    });
  };

  const deleteClient = async (Client) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });

        const res = await axios.delete(
          `${API_BASE_URL}/client?clientid=${Client.ClientID}`,
          config
        );
        await getClients();
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in deleting Client", status: 504 },
        });
        reject(null);
      }
    });
  };

  const getClientGroups = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });
        const res = await axios.get(`${API_BASE_URL}/clientgroups`, config);
        // console.log("APPS", res);
        dispatch({
          type: "SET_CLIENT_GROUP",
          payload: res.data,
        });
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in Fetching Client Groups", status: 504 },
        });
        reject(null);
      }
    });
  };

  const createClientGroup = async (ClientGroup) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });
        const res = await axios.post(
          `${API_BASE_URL}/clientgroup`,
          ClientGroup,
          config
        );
        await getClientGroups();
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in creating client group", status: 504 },
        });
        reject(null);
      }
    });
  };

  const updateClientGroup = async (ClientGroup) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });
        const res = await axios.put(
          `${API_BASE_URL}/clientgroup`,
          ClientGroup,
          config
        );
        await getClientGroups();
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in updating Client Group", status: 504 },
        });
        reject(null);
      }
    });
  };

  const deleteClientGroup = async (ClientGroup) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: APPS_LOADING,
        });
        console.log("deleteClientGroup", ClientGroup);
        const res = await axios.delete(
          `${API_BASE_URL}/clientgroup?groupid=${ClientGroup.GroupID}`,
          config
        );
        await getClientGroups();
        resolve(res.data);
      } catch (err) {
        // console.log("Error Fetching APPs", err);
        dispatch({
          type: FETCH_APPS_ERROR,
          payload: { message: "Error in deleting Client Group", status: 504 },
        });
        reject(null);
      }
    });
  };

  return (
    <ProjectContext.Provider
      value={{
        ...state,
        getProjectsV2,
        setProjects,
        selectProject,
        getServiceAreasV2,
        getServiceAreaFeaturesV2,
        getRolesV2,
        getAssetLookupV2,
        generateNewProjectID,
        generateNewUnitID,
        addRoleV2,
        getProjectServiceAreasV2,
        getProjectAssetsV2,
        getProjectAssetsByUnit,
        getProjectRawAssetsV2,
        clearProjectAssets,
        getEnterpriseUsersV2,
        addProjectUnitsV2,
        addNewUnitsV2,
        deleteProjectUnitsV2,
        updateProjectUnitV2,
        updateProjectStatusV2,
        getProjectAssignmentsV2,
        assignRoleToUserV2,
        deleteFromTableV2,
        updateServiceAreaStatusV2,
        getAllServiceAreasV2,
        generateNewServiceAreaID,
        getWorkflowStatusV2,
        updateWorkflowStatusV2,
        getProjectbyObjectId,
        getAssetGroupsV2,
        getAssetTypesV2,
        getIntelliFiberRoles,
        getIntelliFiberUserRoles,
        getProjectUserRoles,
        getPemissions,
        getRolePermissions,
        addIntelliFiberUserRole,
        getUserRoleType,
        hasUserAccessToProject,
        deleteIntelliFiberUserRole,
        addProjectUserRole,
        deleteProjectUserRole,
        deleteIntelliFiberUnit,
        getPhases,
        getProjectScopeHistoryView,
        getConstructionDashboardLink,
        getRisks,
        addMonthlyStatusRisk,
        deleteMonthlyStatusRisk,
        getProjectMonthlyStatusView,
        addProjectMonthlyStatus,
        deleteProjectMonthlyStatus,
        getMonthlyStatusByObjectId,
        getProjectScopeView,
        getProjectHistoryByObjectId,
        updateProjectScope,
        updateProjectScopeHistory,
        updatePhaseScopeHistory,
        updateProjectDetails,
        /**Intelli-Fiber-Client-Portal APIs */
        getClients,
        getAllUsers,
        getAllRoles,
        getAllProjects,
        getClientProjects,
        getUserProjects,
        getAllUserRoles,
        updateUserRoles,
        createUserRoles,
        deleteUserRoles,
        createUserProjects,
        deleteUserProjects,
        createClientProjects,
        deleteClientProjects,
        setClientUserList,
        setClientGroups,
        createClient,
        updateClient,
        deleteClient,
        getClientGroups,
        createClientGroup,
        updateClientGroup,
        deleteClientGroup,
      }}
    >
      {props.children}
    </ProjectContext.Provider>
  );
};

export default ProjectStore;
